"use client";

import { c as _c } from "react/compiler-runtime";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { Accordion, AccordionContent, AccordionItem } from "@/ds/kit/structure";

/**
 * Questions as filled tiles, opening one at a time; the open one takes the
 * brand colour. The answers are already translated.
 */
export function HomeFaq(t0) {
  const $ = _c(4);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Accordion type="single" collapsible={true} className="mt-10 grid gap-2">{t1}</Accordion>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(item) {
  return <AccordionItem key={item.key} value={item.key} className="rounded-lg border-0 bg-muted/40 px-5 transition-colors data-[state=open]:bg-brand data-[state=open]:text-brand-foreground lg:px-6"><AccordionPrimitive.Header><AccordionPrimitive.Trigger className="group flex min-h-16 w-full items-center justify-between gap-4 py-4 text-left text-lg font-medium">{item.question}<span aria-hidden={true} className="relative size-4 shrink-0 before:absolute before:inset-x-0 before:top-[6.5px] before:h-[3px] before:rounded before:bg-current after:absolute after:inset-x-0 after:top-[6.5px] after:h-[3px] after:rotate-90 after:rounded after:bg-current after:transition-transform group-data-[state=open]:after:rotate-0" /></AccordionPrimitive.Trigger></AccordionPrimitive.Header><AccordionContent className="max-w-[60ch] pb-5 text-base leading-relaxed">{item.answer}</AccordionContent></AccordionItem>;
}